export default __webpack_public_path__ + "static/media/whitepaper.ff370af1.pdf";